varying vec2 vUv; 
varying vec3 vPos;
varying vec3 vNormal; 
// 
uniform vec3 u_camPos;
uniform float u_powerShine;
// 
uniform float u_mixSad;
uniform float u_mixHappy;
uniform float u_mixRound;
uniform float u_gotIdea;

#define PI 3.1415926538

uniform float u_time;
float sdCircle( vec2 p, float r )
{
    return length(p) - r;
}
float smin(float a, float b, float k) {
    float h = clamp(0.5 + 0.5 * (b - a) / k, 0.0, 1.0);
    return mix(b, a, h) - k * h * (1.0 - h);
}
float getEyes(vec2 ndc){
    vec2 newNdc = vec2(ndc.x*2., ndc.y);

    // happy eyes
    vec2 eyePosL = vec2(-0.16, -0.2);
    vec2 eyePosR = vec2(0.16, -0.2);
    float happyEyeL = sdCircle(newNdc-eyePosL, 0.1);
    float happyEyeR = sdCircle(newNdc-eyePosR, 0.1);
    float contreEyeL = sdCircle(vec2(newNdc.x*0.1, newNdc.y*0.4)-vec2(eyePosL.x+0.1, eyePosL.y+0.2), 0.1);
    float contreEyeR = sdCircle(vec2(newNdc.x*0.1, newNdc.y*0.4)-vec2(eyePosR.x-0.1, eyePosR.y+0.2), 0.1);
    happyEyeL = max(happyEyeL, -contreEyeL);
    happyEyeR = max(happyEyeR, -contreEyeR);
    float happyEyes = smin(happyEyeL, happyEyeR, 0.01);
    // sad eyes
    float sadEyeL = sdCircle(newNdc-eyePosL, 0.1);
    float sadEyeR = sdCircle(newNdc-eyePosR, 0.1);
    float contreSadEyeL = sdCircle(vec2(newNdc.x*0.1, newNdc.y*0.4)-vec2(eyePosL.x+0.1, eyePosL.y+0.05), 0.1);
    float contreSadEyeR = sdCircle(vec2(newNdc.x*0.1, newNdc.y*0.4)-vec2(eyePosR.x-0.1, eyePosR.y+0.05), 0.1);
    sadEyeL = max(sadEyeL, -contreSadEyeL);
    sadEyeR = max(sadEyeR, -contreSadEyeR);
    float sadEyes = smin(sadEyeL, sadEyeR, 0.01);
    // round eyes
    float roundEyeL = sdCircle(newNdc-eyePosL, 0.1);
    float roundEyeR = sdCircle(newNdc-eyePosR, 0.1);
    float roundEyes = smin(roundEyeL, roundEyeR, 0.01);
    // float happyEyes = min(eyeL, eyeR);
    // happyEyes = max(happyEyes, -sdCircle(vec2(ndc.x*0.6, ndc.y)-vec2(0., -0.1), 0.15 ));
    float finalEyes = 0.;
    finalEyes = mix(finalEyes, happyEyes, u_mixHappy);
    finalEyes = mix(finalEyes, sadEyes, u_mixSad);
    finalEyes = mix(finalEyes, roundEyes, u_mixRound);
    finalEyes = 1.-smoothstep(0., 0.02, finalEyes);


return finalEyes;
}
void main()
{

    vec2 ndc = (vUv -0.5)*2.;

    vec3 normal = normalize(vNormal);
    if(!gl_FrontFacing)
        normal *= - 1.0;
        
    vec3 pos = vPos;
    // pos *= 100.;
    float angle = atan(pos.x, pos.z);

   float maskHeight = (1.-pos.y-1.)*3.;
   maskHeight *=abs(angle)/PI*0.5;
   maskHeight *=1.-(abs(angle)/PI);
    maskHeight = clamp(maskHeight, 0., 1.);

    float displacement = angle < 0. ? cos(angle*10.+u_time)*(maskHeight) : cos(angle*10.-u_time)*(maskHeight);

    // hologram
      vec3 viewDirection = normalize(vPos - cameraPosition);
    float fresnel = dot(viewDirection, normal) + 1.0;
    fresnel = pow(fresnel, 2.0);
       // Falloff
    float falloff = smoothstep(0.3, 0.8, fresnel);
    // Holographic
    float holographic =  fresnel;
    holographic += fresnel * 1.25;
    // holographic *= falloff;

float eyes = getEyes(ndc);


float globalMask = holographic + eyes;


// ajouter l'obtention d'une idée

// vec3 finalCol = mix(vec3(0.), vec3(1., 0.8, 0.8), globalMask);
// finalCol = mix(finalCol, vec3(0.), holographic);
vec3 finalCol = vec3(0.9137254901960784, 0.592156862745098, 0.5686274509803921);
finalCol = mix(vec3(1.), finalCol*3., u_gotIdea);

    // 
    
    gl_FragColor = vec4(ndc, 0.5, 1.);
    gl_FragColor = vec4(vec3(eyes ), 1.);
    gl_FragColor = vec4(finalCol,globalMask*u_powerShine);
    // gl_FragColor = vec4(normal, 1.);
}